/* This file was created automatically, don't change it manually. */

import React, { forwardRef } from 'react';

import { IconBaseProps } from '../../types';
import { SVGContainer } from '../../SVGContainer';

const IconWb16 = forwardRef<SVGSVGElement, IconBaseProps>(function IconWb16(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 16 16" ref={ref}>
            <path
                d="M11.82 0H4.18A4.18 4.18 0 0 0 0 4.18v7.64A4.18 4.18 0 0 0 4.18 16h7.64A4.181 4.181 0 0 0 16 11.82V4.18A4.18 4.18 0 0 0 11.82 0Z"
                fill="url(#dc-Wb16-a)"
            />
            <path
                d="M4.617 11H3.565L2 5h.957l1.162 4.689L5.376 5h.838l1.249 4.689L8.625 5h.956l-1.565 6H6.965l-1.17-4.38L4.617 11Zm8.608-3.111c.482.274.775.771.775 1.397 0 .488-.158.9-.482 1.225A1.592 1.592 0 0 1 12.34 11H9.968V5h2.198c.45 0 .838.163 1.146.48.316.317.475.711.475 1.183 0 .523-.19.926-.562 1.226Zm-1.06-1.963h-1.288v1.577h1.289c.403 0 .711-.343.711-.789 0-.445-.308-.788-.711-.788Zm-1.288 4.148h1.463c.419 0 .75-.368.75-.84 0-.471-.331-.84-.75-.84h-1.463v1.68Z"
                fill="#fff"
            />
            <defs>
                <linearGradient id="dc-Wb16-a" x1="0" y1="16" x2="16" y2="0" gradientUnits="userSpaceOnUse">
                    <stop offset=".01" stopColor="#CB11AB" />
                    <stop offset=".49" stopColor="#909" />
                    <stop offset="1" stopColor="#481173" />
                </linearGradient>
            </defs>
        </SVGContainer>
    );
});

const IconWb24 = forwardRef<SVGSVGElement, IconBaseProps>(function IconWb24(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 24 24" ref={ref}>
            <path
                d="M17.729 0H6.27A6.271 6.271 0 0 0 0 6.271V17.73A6.271 6.271 0 0 0 6.271 24H17.73A6.271 6.271 0 0 0 24 17.729V6.27A6.271 6.271 0 0 0 17.729 0Z"
                fill="url(#dc-Wb24-a)"
            />
            <path
                d="M6.758 16h-1.51L3 8h1.374l1.669 6.251L7.848 8h1.204l1.794 6.251L12.515 8h1.373l-2.248 8h-1.51l-1.68-5.84L6.758 16Zm12.364-4.149c.693.366 1.113 1.029 1.113 1.863 0 .652-.227 1.2-.693 1.635-.465.434-1.022.651-1.691.651h-3.407V8h3.157c.647 0 1.203.217 1.646.64.454.423.681.949.681 1.577 0 .697-.272 1.234-.806 1.634Zm-1.521-2.617h-1.85v2.103h1.85c.579 0 1.022-.457 1.022-1.051 0-.595-.443-1.052-1.022-1.052Zm-1.85 5.532h2.1c.601 0 1.078-.492 1.078-1.12 0-.629-.477-1.12-1.078-1.12h-2.1v2.24Z"
                fill="#fff"
            />
            <defs>
                <linearGradient id="dc-Wb24-a" x1="0" y1="24" x2="24" y2="0" gradientUnits="userSpaceOnUse">
                    <stop offset=".01" stopColor="#CB11AB" />
                    <stop offset=".49" stopColor="#909" />
                    <stop offset="1" stopColor="#481173" />
                </linearGradient>
            </defs>
        </SVGContainer>
    );
});

export const IconWb = forwardRef<SVGSVGElement, IconBaseProps>(function IconWb(props, ref) {
    const { size = '16' } = props;

    const iconProps = {
        ...props,
        size,
        ref,
    } as const;

    switch (size) {
        case '16':
            return <IconWb16 {...iconProps} />;
        case '24':
            return <IconWb24 {...iconProps} />;
        default:
            return <IconWb24 {...iconProps} />;
    }
});
